<template>
  <div class="pv-gauge-wrap" ref="chartEl" />
</template>

<script>
import echarts from "echarts";

export default {
  name: "PvGaugeChart",
  props: {
    /** 光伏占比 (%)，接口已给百分数时原样使用 */
    photovoltaicRatio: {
      type: [Number, String],
      default: null,
    },
    gridRatio: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    photovoltaicRatio() {
      this.renderOrUpdate();
    },
    gridRatio() {
      this.renderOrUpdate();
    },
  },
  mounted() {
    this.$nextTick(() => this.initShell());
    window.addEventListener("resize", this.onWinResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWinResize);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    onWinResize() {
      setTimeout(() => this.resizeChart(), 100);
    },
    parseRatio(v) {
      if (v == null || v === "") return NaN;
      const n = Number(v);
      return Number.isFinite(n) ? n : NaN;
    },
    getPair() {
      let pv = this.parseRatio(this.photovoltaicRatio);
      let gr = this.parseRatio(this.gridRatio);
      if (!Number.isFinite(pv) && !Number.isFinite(gr)) {
        return [0, 0];
      }
      if (Number.isFinite(pv) && !Number.isFinite(gr)) {
        gr = Math.max(0, 100 - pv);
      }
      if (!Number.isFinite(pv) && Number.isFinite(gr)) {
        pv = Math.max(0, 100 - gr);
      }
      const sum = pv + gr;
      if (sum <= 0) return [0, 0];
      if (Math.abs(sum - 100) > 1) {
        return [(pv / sum) * 100, (gr / sum) * 100];
      }
      return [pv, gr];
    },
    buildOption(pv, gr) {
      return {
        series: [
          {
            type: "pie",
            radius: ["50%", "72%"],
            avoidLabelOverlap: false,
            label: { show: false },
            emphasis: { scale: false },
            data: [
              {
                value: Math.round(pv * 10) / 10,
                name: "光伏发电",
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#ffa500" },
                      { offset: 1, color: "#ff8c00" },
                    ],
                  },
                },
              },
              {
                value: Math.round(gr * 10) / 10,
                name: "市电",
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#00d4ff" },
                      { offset: 1, color: "#0091ea" },
                    ],
                  },
                },
              },
            ],
          },
        ],
      };
    },
    initShell() {
      if (!this.$refs.chartEl) return;
      this.chart = echarts.init(this.$refs.chartEl);
      this.renderOrUpdate();
      setTimeout(() => this.resizeChart(), 200);
    },
    renderOrUpdate() {
      if (!this.chart) return;
      const [pv, gr] = this.getPair();
      this.chart.setOption(this.buildOption(pv, gr));
    },
    resizeChart() {
      if (this.chart) this.chart.resize();
    },
  },
};
</script>
